import { Component, OnInit } from '@angular/core';
import {FeatureGroupService} from "../../services/feature-group.service";
import {CreateFeatureGroupDto} from "../../dto/create-feature-group.dto";
import {FeatureGroup} from "../../model/feature-group.model";
import {ModalController} from "@ionic/angular/standalone";
import { IonHeader, IonToolbar, IonTitle, IonContent } from "@ionic/angular/standalone";
import {EditFeatureGroupPage} from "../edit-feature-group/edit-feature-group.page";
import { SuperButtonComponent, SuperInputComponent } from '@qid/super';
import { SexyModule } from '@qid/sexy';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-feature-group',
  templateUrl: './feature-group.page.html',
  styleUrls: ['./feature-group.page.scss'],
  standalone: true,
  imports: [
    FormsModule,
    SexyModule,
    SuperButtonComponent,
    SuperInputComponent,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent
]
})
export class FeatureGroupPage implements OnInit {

  public createFeatureGroupDto : CreateFeatureGroupDto = new CreateFeatureGroupDto();
  public featureGroups : FeatureGroup[] = []
  constructor(private featureGroupService : FeatureGroupService,
              private modalController : ModalController
              ) { }

  ngOnInit() {
  }

  ionViewDidEnter(){
    this.fetchGroups()
  }

  public create = async ()=>{
    await this.featureGroupService.create(this.createFeatureGroupDto)
    await this.fetchGroups();
  }

  public async fetchGroups(){
    this.featureGroups = await this.featureGroupService.readAll();
  }

  onNameChange() {

    if(!this.createFeatureGroupDto.name){
      return;
    }

      let split = this.createFeatureGroupDto.name.split(" ");
      let joi = split.join("_");
      this.createFeatureGroupDto.keyName = joi.toLowerCase()

  }

  async editFeatureGroup(featureGroup: FeatureGroup){
    const modal = await this.modalController.create({
      component : EditFeatureGroupPage,
      componentProps : {
        featureGroup : featureGroup
      }
    })

    modal.present();
  }

  delete = async (id)=>{
    await this.featureGroupService.delete(id)
    this.ionViewDidEnter()
  }
}
